import { z } from 'zod';

const lineSchema = z.object({
  mtrId: z.string().min(1, '物料缺少 id'),
  mtrNo: z.string().optional().nullable(),
  mtrName: z.string().optional().nullable(),
  unscheduledQty: z.union([z.string(), z.number(), z.null()]).optional().nullable(),
  plannedQty: z.union([z.string(), z.number(), z.null()]),
}).superRefine((line, ctx) => {
  const qty = line.plannedQty;
  const n = Number(qty);
  if (qty === '' || qty == null || Number.isNaN(n) || n <= 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: '計劃量須大於 0',
      path: ['plannedQty'],
    });
  }
});

export const arrivalScheduleFormSchema = z.object({
  expectedArrivalDate: z.string().min(1, '請填寫預計到貨日'),
  remark: z.string().optional().nullable(),
  lines: z.array(lineSchema).min(1, '至少一筆明細').superRefine((lines, ctx) => {
    const seen = new Set();
    lines.forEach((line, index) => {
      const id = line.mtrId?.trim();
      if (!id) {
        return;
      }
      if (seen.has(id)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: '同一物料不可重複',
          path: [index, 'mtrId'],
        });
        return;
      }
      seen.add(id);
    });
  }),
});

export const ARRIVAL_SCHEDULE_FIELD_LABELS = {
  expectedArrivalDate: '預計到貨日',
  remark: '備註',
  lines: '排程明細',
};

export const ARRIVAL_SCHEDULE_LINES_TIP =
  '依採購單物料建立排程列；以物料 id（mtr.id）對應後端 mtr_id，不送 line_no、不用陣列 index。';
